module.exports = __webpack_public_path__ + "34571bd9320889fba28215ca0df4a7bd.jpg";